import { Theme, createTheme } from '@mui/material/styles';
import { palette } from './palette';
import { typography } from './typography';

declare module '@mui/material/styles' {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface DefaultTheme extends Theme {}
}

export const theme = createTheme({
    palette,
    typography: typography as any,
    zIndex: {
        appBar: 1200,
        drawer: 1100,
        // The Tailwind `CustomModal` overlay sits at z-1400 (see
        // `pages/common/CustomModal.tsx`) — above MUI's default overlay layer
        // (modal 1300). Any MUI popup opened from inside a CustomModal — the
        // date-picker Popper, the TimePicker clock, a Select menu — therefore
        // rendered *behind* the full-screen overlay, which swallowed the click
        // and made the field look dead (SUP/product-rental booking edit).
        // Lift the MUI overlay layers above it, keeping MUI's own
        // modal < snackbar < tooltip ordering intact.
        modal: 1500,
        snackbar: 1600,
        tooltip: 1700,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: 'white',
                    color: '#333',
                    fontSize: '0.75rem',
                    boxShadow: '0 5px 20px rgba(0,0,0,0.25), 0 2px 6px rgba(0,0,0,0.12)',
                },
            },
        },
    },
});
